import {
    ChangeDetectionStrategy,
    Component, ElementRef, OnInit,
    ViewChild
} from "@angular/core";
import Highcharts from "highcharts";
import Exporting from "highcharts/modules/exporting";
import funnel from "highcharts/modules/funnel";


Exporting(Highcharts);
funnel(Highcharts);

@Component({
  selector: "app-analytics-email-conversion",
  templateUrl: "./analytics-email-conversion.component.html",
  styleUrls: ["./analytics-email-conversion.component.scss"],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class AnalyticsEmailConversionComponent implements OnInit {
  @ViewChild("container", { read: ElementRef, static: true })
  container: ElementRef;

  constructor() {}

  ngOnInit() {
    Highcharts.setOptions({
      colors: ["#03c0c2", "#868E96", "#72CACB"],
    });

    Highcharts.chart(this.container.nativeElement, {
      chart: {
        height: 330,
        type: "funnel",
      },
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      exporting: {
        buttons: {
          contextButton: {
            enabled: false,
          },
        },
      },
      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            format: "<b>{point.name}</b> ({point.y:,.0f})",
            // color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || '#03c0c2',

            softConnector: true,
          },
          center: ["40%", "50%"],
          neckWidth: "20%",
          neckHeight: "7%",
          width: "50%",
          height: "250px",
        },
      },
      legend: {
        enabled: false,
      },
      series: [
        {
          name: "Unique users",
          data: [
            ["Sent", 5090],
            ["Opened", 2355],
            ["Clicked", 1235],
          ],
        },
      ],
    });
  }
}
